export default "__VITE_ASSET__D0nCIz22__"